const isAreaNotUnique = (areaName,property) => {
  const areasMapped={kitchen:'numKitchen',livingRoom:'numLivingRoom',bathroom:'numBathroom'}
  const areaNumber=property[areasMapped[areaName?.split('_')?.[0]]];
  return areaNumber>1;
}

export default isAreaNotUnique;
